import 'isomorphic-fetch';
import fetchCheck from '../redux/middleware/fetchCheck';

/**
 * @typedef {import('../containers/Pages/MultiMediaWizard/types/Sequences').Sequence} Sequence
 * @typedef {import('../containers/Pages/MultiMediaWizard/types/Assignments').Assignment} Device
 * @typedef {import('../containers/Pages/MultiMediaWizard/types/ScheduleValue').ScheduleValue} ScheduleValue
 */

const url = '/cms/data/v1/wizard/';
const credentials = 'include';
const headers = { Accept: 'application/json', 'Content-Type': 'application/json' };

/**
 * Creates a new sequence via the wizard API.
 * @param {Sequence} sequence - The sequence data to create.
 * @param {Device[]} devices - The devices to assign the sequence to.
 * @param {number} campaignId - The campaign ID to associate with the sequence.
 * @param {ScheduleValue} schedule - The schedule data to associate with the sequence.
 * @returns {Promise} A promise that resolves when the sequence is created and devices are assigned.
 */
export const createSequence = async (sequence, devices, campaignId, schedule) => {
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify({ sequence, devices, campaignId, schedule }),
    credentials,
    headers,
  })
    .then(res => fetchCheck(res))
    .then(res => res.json());
};
